// Learner App does not support translation (see /learnerApp/src/App.tsx)
/* eslint-disable i18next/no-literal-string */
import { Button } from "@outschool/backpack";
import React from "react";

import { TopicFilter } from "./consts";

export default function TopicFilterButton({
  filter,
  selectedFilter,
  onFilterChange,
}: {
  filter: TopicFilter;
  selectedFilter: TopicFilter;
  onFilterChange: (filter: TopicFilter) => void;
}) {
  const isSelected = selectedFilter === filter;

  return (
    <Button
      variant={isSelected ? "contained" : "outlined"}
      color="primary"
      size="small"
      onClick={() => onFilterChange(filter)}
    >
      {filter}
    </Button>
  );
}
